import { Route, Routes, useLocation } from 'react-router'

import AppLayout from '../components/Layouts/AppLayout/AppLayout'
import useScrollToTop from './hooks/useScrollToTop'

import BuyTicketVoucher from 'pages/BuyTicketVoucher/BuyTicketVoucher'
import ChangeForgottenPassword from '../pages/ChangeForgottenPassword/ChangeForgottenPassword'
import ContactInfo from '../pages/ContactInfo/ContactInfo'
import Demo from '../pages/Demo/Demo'
import ExpiredLimit from '../pages/ExpiredLimit/ExpiredLimit'
import ForgottenPassword from '../pages/ForgottenPassword/ForgottenPassword'
import Hall from '../pages/Hall/Hall'
import HealthCheck from '../pages/HealthCheck/HealthCheck'
import Login from '../pages/Login/Login'
import OrderSummary from '../pages/OrderSummary/OrderSummary'
import Page404 from '../pages/Page404/Page404'
import Page500 from '../pages/Page500/Page500'
import PaymentFailed from '../pages/PaymentFailed/PaymentFailed'
import PaymentVerify from '../pages/PaymentVerify/PaymentVerify'
import Register from '../pages/Register/Register'
import ThanksForOrder from '../pages/ThanksForOrder/ThanksForOrder'
import TicketsReserved from '../pages/TicketsReserved/TicketsReserved'
import UserProfile from '../pages/UserProfile/UserProfile'
import YourOrder from '../pages/YourOrder/YourOrder'

import { PATH_NAME } from './constants'

import MainLayout from 'components/Layouts/MainLayout/MainLayout'
import Gdpr from 'pages/GDPR/Gdpr'
import Maintenance from '../pages/Maintenance/Maintenance'
import hocRouter from './hocRouter'
import useMaintenance from './hooks/useMaintenance'

const Router = ({ isClubMember }) => {
    const { pathname } = useLocation()

    useScrollToTop(pathname, isClubMember)
    useMaintenance()

    return (
        <Routes>
            <Route path={PATH_NAME.EXACT} exact element={<MainLayout />}>
                <Route path={PATH_NAME.EXACT} exact element={<AppLayout />}>
                    <Route index element={<Hall />} />
                    <Route path={PATH_NAME.YOUR_ORDER} element={<YourOrder />} />
                    <Route path={PATH_NAME.CONTACT_INFO} element={<ContactInfo />} />
                    <Route path={PATH_NAME.ORDER_SUMMARY} element={<OrderSummary />} />
                    <Route path={PATH_NAME.DEMO} element={<Demo />} />
                    <Route path={PATH_NAME.USER_PROFILE} element={<UserProfile />} />
                    <Route path={PATH_NAME.LOGIN} element={<Login />} />
                    <Route path={PATH_NAME.REGISTER} element={<Register />} />
                    <Route path={PATH_NAME.FORGOTTEN_PASSWORD} element={<ForgottenPassword />} />
                    <Route path={PATH_NAME.CHANGE_FORGOTTEN_PASSWORD} element={<ChangeForgottenPassword />} />
                    <Route path={PATH_NAME.THANKS_FOR_ORDER} element={<ThanksForOrder />} />
                    <Route path={PATH_NAME.TICKETS_RESERVED} element={<TicketsReserved />} />
                    <Route path={PATH_NAME.PAYMENT_FAILED} element={<PaymentFailed />} />
                    <Route path={PATH_NAME.EXPIRED_LIMIT} element={<ExpiredLimit />} />
                    <Route path={PATH_NAME.BUY_TICKET_VOUCHER} element={<BuyTicketVoucher />} />

                    <Route path={PATH_NAME.GDPR} element={<Gdpr />} />
                </Route>
                <Route path={PATH_NAME.EXACT} exact element={<AppLayout withoutApp />}>
                    <Route path={PATH_NAME.ERROR} element={<Page500 />} />
                    <Route path={PATH_NAME.NOT_FOUND} element={<Page404 />} />
                    <Route path={PATH_NAME.EVERYTHING_ELSE} element={<Page404 />} />
                    <Route path={PATH_NAME.VERIFY_PAYMENT} element={<PaymentVerify />} />
                    <Route path={PATH_NAME.Maintenance} element={<Maintenance />} />
                </Route>
            </Route>
            <Route path={PATH_NAME.HEALTHCHECK} exact element={<HealthCheck />} />
        </Routes>
    )
}

export default hocRouter(Router)
